// SPDX-License-Identifier: AGPL-3.0-or-later

import Authentication from '@app/features/auth/state/Authentication';
import type {ReactionEmoji} from '@app/features/messaging/utils/ReactionUtils';

type AddReactionListener = (channelId: string, messageId: string, emoji: ReactionEmoji) => void;
const addReactionListeners = new Set<AddReactionListener>();

export function subscribeAddReaction(listener: AddReactionListener): () => void {
	addReactionListeners.add(listener);
	return () => {
		addReactionListeners.delete(listener);
	};
}

export function notifyAddReaction(channelId: string, messageId: string, emoji: ReactionEmoji): void {
	for (const listener of addReactionListeners) {
		listener(channelId, messageId, emoji);
	}
}

export function notifyRemoteAddReaction(
	channelId: string,
	messageId: string,
	emoji: ReactionEmoji,
	reactorUserId: string,
): void {
	if (Authentication.currentUserId != null && String(reactorUserId) === String(Authentication.currentUserId)) return;
	notifyAddReaction(channelId, messageId, emoji);
}
